// source: acompanha/printers/v1/printers.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.printers.v1.CreatePrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.CreatePrinterResponse', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.DeletePrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.GetPrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.GetPrinterResponse', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.ListPrinterFilamentsRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.ListPrinterFilamentsResponse', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.ListPrintersRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.ListPrintersResponse', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.Printer', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.PrinterFilamentAssignment', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.PrinterFilamentInput', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.PrinterListItem', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.SetPrinterFilamentsRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.SetPrinterFilamentsResponse', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.UnassignPrinterFilamentRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.UpdatePrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.printers.v1.UpdatePrinterResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.PrinterFilamentAssignment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.PrinterFilamentAssignment.displayName = 'proto.acompanha.printers.v1.PrinterFilamentAssignment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.PrinterListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.PrinterListItem.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.PrinterListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.PrinterListItem.displayName = 'proto.acompanha.printers.v1.PrinterListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.Printer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.Printer.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.Printer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.Printer.displayName = 'proto.acompanha.printers.v1.Printer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.ListPrintersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.ListPrintersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.ListPrintersRequest.displayName = 'proto.acompanha.printers.v1.ListPrintersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.ListPrintersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.ListPrintersResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.ListPrintersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.ListPrintersResponse.displayName = 'proto.acompanha.printers.v1.ListPrintersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.GetPrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.GetPrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.GetPrinterRequest.displayName = 'proto.acompanha.printers.v1.GetPrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.GetPrinterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.GetPrinterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.GetPrinterResponse.displayName = 'proto.acompanha.printers.v1.GetPrinterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.CreatePrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.CreatePrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.CreatePrinterRequest.displayName = 'proto.acompanha.printers.v1.CreatePrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.CreatePrinterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.CreatePrinterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.CreatePrinterResponse.displayName = 'proto.acompanha.printers.v1.CreatePrinterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.UpdatePrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.UpdatePrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.UpdatePrinterRequest.displayName = 'proto.acompanha.printers.v1.UpdatePrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.UpdatePrinterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.UpdatePrinterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.UpdatePrinterResponse.displayName = 'proto.acompanha.printers.v1.UpdatePrinterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.DeletePrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.DeletePrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.DeletePrinterRequest.displayName = 'proto.acompanha.printers.v1.DeletePrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.ListPrinterFilamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.ListPrinterFilamentsRequest.displayName = 'proto.acompanha.printers.v1.ListPrinterFilamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.ListPrinterFilamentsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.ListPrinterFilamentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.ListPrinterFilamentsResponse.displayName = 'proto.acompanha.printers.v1.ListPrinterFilamentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.PrinterFilamentInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.PrinterFilamentInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.PrinterFilamentInput.displayName = 'proto.acompanha.printers.v1.PrinterFilamentInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.SetPrinterFilamentsRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.SetPrinterFilamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.SetPrinterFilamentsRequest.displayName = 'proto.acompanha.printers.v1.SetPrinterFilamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printers.v1.SetPrinterFilamentsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printers.v1.SetPrinterFilamentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.SetPrinterFilamentsResponse.displayName = 'proto.acompanha.printers.v1.SetPrinterFilamentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printers.v1.UnassignPrinterFilamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.displayName = 'proto.acompanha.printers.v1.UnassignPrinterFilamentRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
filamentUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
location: jspb.Message.getFieldWithDefault(msg, 3, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
color: jspb.Message.getFieldWithDefault(msg, 6, ""),
colorLabel: jspb.Message.getFieldWithDefault(msg, 7, ""),
brand: jspb.Message.getFieldWithDefault(msg, 8, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 9, ""),
printerName: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.PrinterFilamentAssignment;
  return proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPrinterName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filament_uuid = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string location = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 sort_order = 4;
 * @return {number}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string color = 6;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string color_label = 7;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string brand = 8;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string printer_uuid = 9;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string printer_name = 10;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.getPrinterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentAssignment.prototype.setPrinterName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.PrinterListItem.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.PrinterListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.PrinterListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
consumption: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
price: jspb.Message.getFieldWithDefault(msg, 6, 0),
active: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
printerModelUuid: jspb.Message.getFieldWithDefault(msg, 8, ""),
avgConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 9, 0),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.PrinterListItem}
 */
proto.acompanha.printers.v1.PrinterListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.PrinterListItem;
  return proto.acompanha.printers.v1.PrinterListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.PrinterListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.PrinterListItem}
 */
proto.acompanha.printers.v1.PrinterListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConsumption(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModelUuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    case 10:
      var value = new proto.acompanha.printers.v1.PrinterFilamentAssignment;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.PrinterListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.PrinterListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConsumption();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPrinterModelUuid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAvgConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double consumption = 5;
 * @return {number}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getConsumption = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setConsumption = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 price = 6;
 * @return {number}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool active = 7;
 * @return {boolean}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string printer_model_uuid = 8;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getPrinterModelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setPrinterModelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 avg_consumption_watts = 9;
 * @return {number}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated PrinterFilamentAssignment filaments = 10;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterFilamentAssignment, 10));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} value
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
*/
proto.acompanha.printers.v1.PrinterListItem.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.acompanha.printers.v1.PrinterFilamentAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.PrinterListItem} returns this
 */
proto.acompanha.printers.v1.PrinterListItem.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.Printer.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.Printer.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.Printer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.Printer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.Printer.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
powerConsumptionWatts: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
acquisitionValue: jspb.Message.getFieldWithDefault(msg, 6, 0),
acquisitionDate: (f = msg.getAcquisitionDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
hourlyPrintingCost: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
active: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
printerModelUuid: jspb.Message.getFieldWithDefault(msg, 12, ""),
avgConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 13, 0),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.Printer}
 */
proto.acompanha.printers.v1.Printer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.Printer;
  return proto.acompanha.printers.v1.Printer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.Printer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.Printer}
 */
proto.acompanha.printers.v1.Printer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPowerConsumptionWatts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAcquisitionValue(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAcquisitionDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHourlyPrintingCost(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModelUuid(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    case 14:
      var value = new proto.acompanha.printers.v1.PrinterFilamentAssignment;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.Printer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.Printer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.Printer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.Printer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPowerConsumptionWatts();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getAcquisitionValue();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAcquisitionDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHourlyPrintingCost();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getPrinterModelUuid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAvgConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.Printer.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.Printer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.Printer.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.acompanha.printers.v1.Printer.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double power_consumption_watts = 5;
 * @return {number}
 */
proto.acompanha.printers.v1.Printer.prototype.getPowerConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setPowerConsumptionWatts = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 acquisition_value = 6;
 * @return {number}
 */
proto.acompanha.printers.v1.Printer.prototype.getAcquisitionValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setAcquisitionValue = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp acquisition_date = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printers.v1.Printer.prototype.getAcquisitionDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
*/
proto.acompanha.printers.v1.Printer.prototype.setAcquisitionDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.clearAcquisitionDate = function() {
  return this.setAcquisitionDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.Printer.prototype.hasAcquisitionDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 hourly_printing_cost = 8;
 * @return {number}
 */
proto.acompanha.printers.v1.Printer.prototype.getHourlyPrintingCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setHourlyPrintingCost = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printers.v1.Printer.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
*/
proto.acompanha.printers.v1.Printer.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.Printer.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printers.v1.Printer.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
*/
proto.acompanha.printers.v1.Printer.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.Printer.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool active = 11;
 * @return {boolean}
 */
proto.acompanha.printers.v1.Printer.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string printer_model_uuid = 12;
 * @return {string}
 */
proto.acompanha.printers.v1.Printer.prototype.getPrinterModelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setPrinterModelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 avg_consumption_watts = 13;
 * @return {number}
 */
proto.acompanha.printers.v1.Printer.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated PrinterFilamentAssignment filaments = 14;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>}
 */
proto.acompanha.printers.v1.Printer.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterFilamentAssignment, 14));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} value
 * @return {!proto.acompanha.printers.v1.Printer} returns this
*/
proto.acompanha.printers.v1.Printer.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.Printer.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.acompanha.printers.v1.PrinterFilamentAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.Printer} returns this
 */
proto.acompanha.printers.v1.Printer.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.ListPrintersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.ListPrintersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.ListPrintersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrintersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.ListPrintersRequest}
 */
proto.acompanha.printers.v1.ListPrintersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.ListPrintersRequest;
  return proto.acompanha.printers.v1.ListPrintersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.ListPrintersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.ListPrintersRequest}
 */
proto.acompanha.printers.v1.ListPrintersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.ListPrintersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.ListPrintersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.ListPrintersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrintersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.printers.v1.ListPrintersRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.printers.v1.ListPrintersRequest} returns this
*/
proto.acompanha.printers.v1.ListPrintersRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.ListPrintersRequest} returns this
 */
proto.acompanha.printers.v1.ListPrintersRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.ListPrintersRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.ListPrintersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.ListPrintersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.ListPrintersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrintersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
printersList: jspb.Message.toObjectList(msg.getPrintersList(),
    proto.acompanha.printers.v1.PrinterListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse}
 */
proto.acompanha.printers.v1.ListPrintersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.ListPrintersResponse;
  return proto.acompanha.printers.v1.ListPrintersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.ListPrintersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse}
 */
proto.acompanha.printers.v1.ListPrintersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.PrinterListItem;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterListItem.deserializeBinaryFromReader);
      msg.addPrinters(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.ListPrintersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.ListPrintersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrintersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrintersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.printers.v1.PrinterListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PrinterListItem printers = 1;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterListItem>}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.getPrintersList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterListItem>} value
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse} returns this
*/
proto.acompanha.printers.v1.ListPrintersResponse.prototype.setPrintersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterListItem}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.addPrinters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.printers.v1.PrinterListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse} returns this
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.clearPrintersList = function() {
  return this.setPrintersList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse} returns this
*/
proto.acompanha.printers.v1.ListPrintersResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.ListPrintersResponse} returns this
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.ListPrintersResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.GetPrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.GetPrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.GetPrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.GetPrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.GetPrinterRequest}
 */
proto.acompanha.printers.v1.GetPrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.GetPrinterRequest;
  return proto.acompanha.printers.v1.GetPrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.GetPrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.GetPrinterRequest}
 */
proto.acompanha.printers.v1.GetPrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.GetPrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.GetPrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.GetPrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.GetPrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.GetPrinterRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.GetPrinterRequest} returns this
 */
proto.acompanha.printers.v1.GetPrinterRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.GetPrinterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.GetPrinterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.GetPrinterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.GetPrinterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printers.v1.Printer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.GetPrinterResponse}
 */
proto.acompanha.printers.v1.GetPrinterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.GetPrinterResponse;
  return proto.acompanha.printers.v1.GetPrinterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.GetPrinterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.GetPrinterResponse}
 */
proto.acompanha.printers.v1.GetPrinterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.Printer;
      reader.readMessage(value,proto.acompanha.printers.v1.Printer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.GetPrinterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.GetPrinterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.GetPrinterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.GetPrinterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printers.v1.Printer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Printer data = 1;
 * @return {?proto.acompanha.printers.v1.Printer}
 */
proto.acompanha.printers.v1.GetPrinterResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printers.v1.Printer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printers.v1.Printer, 1));
};


/**
 * @param {?proto.acompanha.printers.v1.Printer|undefined} value
 * @return {!proto.acompanha.printers.v1.GetPrinterResponse} returns this
*/
proto.acompanha.printers.v1.GetPrinterResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.GetPrinterResponse} returns this
 */
proto.acompanha.printers.v1.GetPrinterResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.GetPrinterResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.CreatePrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.CreatePrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
model: jspb.Message.getFieldWithDefault(msg, 3, ""),
powerConsumptionWatts: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
acquisitionValue: jspb.Message.getFieldWithDefault(msg, 5, 0),
acquisitionDate: (f = msg.getAcquisitionDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
hourlyPrintingCost: jspb.Message.getFieldWithDefault(msg, 7, 0),
active: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f,
printerModelUuid: jspb.Message.getFieldWithDefault(msg, 9, ""),
avgConsumptionWatts: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.CreatePrinterRequest;
  return proto.acompanha.printers.v1.CreatePrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPowerConsumptionWatts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAcquisitionValue(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAcquisitionDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHourlyPrintingCost(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModelUuid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.CreatePrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.CreatePrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.CreatePrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPowerConsumptionWatts();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getAcquisitionValue();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAcquisitionDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHourlyPrintingCost();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getPrinterModelUuid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double power_consumption_watts = 4;
 * @return {number}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getPowerConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setPowerConsumptionWatts = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 acquisition_value = 5;
 * @return {number}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getAcquisitionValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setAcquisitionValue = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp acquisition_date = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getAcquisitionDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
*/
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setAcquisitionDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.clearAcquisitionDate = function() {
  return this.setAcquisitionDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.hasAcquisitionDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int64 hourly_printing_cost = 7;
 * @return {number}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getHourlyPrintingCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setHourlyPrintingCost = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool active = 8;
 * @return {boolean}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setActive = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.clearActive = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.hasActive = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string printer_model_uuid = 9;
 * @return {string}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getPrinterModelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setPrinterModelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 avg_consumption_watts = 10;
 * @return {number}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.printers.v1.CreatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.clearAvgConsumptionWatts = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.CreatePrinterRequest.prototype.hasAvgConsumptionWatts = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.CreatePrinterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.CreatePrinterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.CreatePrinterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printers.v1.Printer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.CreatePrinterResponse}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.CreatePrinterResponse;
  return proto.acompanha.printers.v1.CreatePrinterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.CreatePrinterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.CreatePrinterResponse}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.Printer;
      reader.readMessage(value,proto.acompanha.printers.v1.Printer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.CreatePrinterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.CreatePrinterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.CreatePrinterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printers.v1.Printer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Printer data = 1;
 * @return {?proto.acompanha.printers.v1.Printer}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printers.v1.Printer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printers.v1.Printer, 1));
};


/**
 * @param {?proto.acompanha.printers.v1.Printer|undefined} value
 * @return {!proto.acompanha.printers.v1.CreatePrinterResponse} returns this
*/
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.CreatePrinterResponse} returns this
 */
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.CreatePrinterResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.UpdatePrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
powerConsumptionWatts: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
acquisitionValue: jspb.Message.getFieldWithDefault(msg, 6, 0),
acquisitionDate: (f = msg.getAcquisitionDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
hourlyPrintingCost: jspb.Message.getFieldWithDefault(msg, 8, 0),
active: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
printerModelUuid: jspb.Message.getFieldWithDefault(msg, 10, ""),
avgConsumptionWatts: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.UpdatePrinterRequest;
  return proto.acompanha.printers.v1.UpdatePrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPowerConsumptionWatts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAcquisitionValue(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAcquisitionDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHourlyPrintingCost(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModelUuid(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.UpdatePrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.UpdatePrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPowerConsumptionWatts();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getAcquisitionValue();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAcquisitionDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHourlyPrintingCost();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getPrinterModelUuid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double power_consumption_watts = 5;
 * @return {number}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getPowerConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setPowerConsumptionWatts = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 acquisition_value = 6;
 * @return {number}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getAcquisitionValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setAcquisitionValue = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp acquisition_date = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getAcquisitionDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
*/
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setAcquisitionDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.clearAcquisitionDate = function() {
  return this.setAcquisitionDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.hasAcquisitionDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 hourly_printing_cost = 8;
 * @return {number}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getHourlyPrintingCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setHourlyPrintingCost = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool active = 9;
 * @return {boolean}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setActive = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.clearActive = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.hasActive = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string printer_model_uuid = 10;
 * @return {string}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getPrinterModelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setPrinterModelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 avg_consumption_watts = 11;
 * @return {number}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterRequest} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.clearAvgConsumptionWatts = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.UpdatePrinterRequest.prototype.hasAvgConsumptionWatts = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.UpdatePrinterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.UpdatePrinterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printers.v1.Printer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterResponse}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.UpdatePrinterResponse;
  return proto.acompanha.printers.v1.UpdatePrinterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.UpdatePrinterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterResponse}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.Printer;
      reader.readMessage(value,proto.acompanha.printers.v1.Printer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.UpdatePrinterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.UpdatePrinterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printers.v1.Printer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Printer data = 1;
 * @return {?proto.acompanha.printers.v1.Printer}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printers.v1.Printer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printers.v1.Printer, 1));
};


/**
 * @param {?proto.acompanha.printers.v1.Printer|undefined} value
 * @return {!proto.acompanha.printers.v1.UpdatePrinterResponse} returns this
*/
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printers.v1.UpdatePrinterResponse} returns this
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printers.v1.UpdatePrinterResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.DeletePrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.DeletePrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.DeletePrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.DeletePrinterRequest}
 */
proto.acompanha.printers.v1.DeletePrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.DeletePrinterRequest;
  return proto.acompanha.printers.v1.DeletePrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.DeletePrinterRequest}
 */
proto.acompanha.printers.v1.DeletePrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.DeletePrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.DeletePrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.DeletePrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.DeletePrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.DeletePrinterRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.DeletePrinterRequest} returns this
 */
proto.acompanha.printers.v1.DeletePrinterRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.ListPrinterFilamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.ListPrinterFilamentsRequest;
  return proto.acompanha.printers.v1.ListPrinterFilamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.ListPrinterFilamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsRequest} returns this
 */
proto.acompanha.printers.v1.ListPrinterFilamentsRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.ListPrinterFilamentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.ListPrinterFilamentsResponse;
  return proto.acompanha.printers.v1.ListPrinterFilamentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.PrinterFilamentAssignment;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.ListPrinterFilamentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PrinterFilamentAssignment filaments = 1;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterFilamentAssignment, 1));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} value
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse} returns this
*/
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.printers.v1.PrinterFilamentAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.ListPrinterFilamentsResponse} returns this
 */
proto.acompanha.printers.v1.ListPrinterFilamentsResponse.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.PrinterFilamentInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.PrinterFilamentInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterFilamentInput.toObject = function(includeInstance, msg) {
  var f, obj = {
filamentUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
location: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.PrinterFilamentInput}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.PrinterFilamentInput;
  return proto.acompanha.printers.v1.PrinterFilamentInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.PrinterFilamentInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.PrinterFilamentInput}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.PrinterFilamentInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.PrinterFilamentInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.PrinterFilamentInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string filament_uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentInput} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.PrinterFilamentInput} returns this
 */
proto.acompanha.printers.v1.PrinterFilamentInput.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.SetPrinterFilamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.printers.v1.PrinterFilamentInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.SetPrinterFilamentsRequest;
  return proto.acompanha.printers.v1.SetPrinterFilamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = new proto.acompanha.printers.v1.PrinterFilamentInput;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterFilamentInput.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.SetPrinterFilamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.printers.v1.PrinterFilamentInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} returns this
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PrinterFilamentInput filaments = 2;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentInput>}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterFilamentInput, 2));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentInput>} value
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} returns this
*/
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentInput}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.printers.v1.PrinterFilamentInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsRequest} returns this
 */
proto.acompanha.printers.v1.SetPrinterFilamentsRequest.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.SetPrinterFilamentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.printers.v1.PrinterFilamentAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.SetPrinterFilamentsResponse;
  return proto.acompanha.printers.v1.SetPrinterFilamentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printers.v1.PrinterFilamentAssignment;
      reader.readMessage(value,proto.acompanha.printers.v1.PrinterFilamentAssignment.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.SetPrinterFilamentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.printers.v1.PrinterFilamentAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PrinterFilamentAssignment filaments = 1;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printers.v1.PrinterFilamentAssignment, 1));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} value
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse} returns this
*/
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.printers.v1.PrinterFilamentAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printers.v1.SetPrinterFilamentsResponse} returns this
 */
proto.acompanha.printers.v1.SetPrinterFilamentsResponse.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
assignmentUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
filamentUuid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printers.v1.UnassignPrinterFilamentRequest;
  return proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssignmentUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssignmentUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} returns this
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string assignment_uuid = 2;
 * @return {string}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.getAssignmentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} returns this
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.setAssignmentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string filament_uuid = 3;
 * @return {string}
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printers.v1.UnassignPrinterFilamentRequest} returns this
 */
proto.acompanha.printers.v1.UnassignPrinterFilamentRequest.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.acompanha.printers.v1);
